"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createViralSerology = createViralSerology;
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const hbvStatus_1 = require("../../../forms/ktx/basic-registration-data/viral-serology/hbvStatus");
const hcv_1 = require("../../../forms/ktx/basic-registration-data/viral-serology/hcv");
const messages = {
    title: {
        id: "ktx.dashboard.viral_serology",
        defaultMessage: "Vírusszerológia"
    },
    igg: {
        id: "ktx.dashboard.viral_serology.igg",
        defaultMessage: "IgG"
    },
    igm: {
        id: "ktx.dashboard.viral_serology.igm",
        defaultMessage: "IgM"
    },
    aHBctotal: {
        id: "ktx.dashboard.viral_serology.aHBctotal",
        defaultMessage: "aHBc totál"
    },
    antiHBs: {
        id: "ktx.dashboard.viral_serology.antiHBs",
        defaultMessage: "antiHBs"
    },
    antiHBsValue: {
        id: "ktx.dashboard.viral_serology.antiHBsValue",
        defaultMessage: "antiHBs értéke"
    },
    hbsAg: {
        id: "ktx.dashboard.viral_serology.hbsAg",
        defaultMessage: "HBs-Ag"
    },
    HBImmun: {
        id: "ktx.dashboard.viral_serology.HBImmun",
        defaultMessage: "HB immunizáció"
    }
};
function createViralSerology(intl, options) {
    const list = createList(intl, options);
    const content = (0, shared_1.createSectionContent)(list);
    return (0, shared_1.createSection)(intl, { label: messages.title, content });
}
function createList({ formatMessage, formatMessageMap, formatDate }, { events }) {
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.viralSerologyQueries.viralSerology);
    return relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        const items = [];
        const iggIgmType = !!event.value.igG;
        const hbvType = !!event.value.antiHBs;
        const resultType = !!event.value.result;
        const label = shared_1.fsnMessages[(0, utils_1.mapInterpretationToString)(event.interpretation)];
        if (resultType) {
            items.push({
                type: "list-item",
                value: formatMessageMap(hcv_1.resultMessages, event.value.result)
            });
        }
        if (iggIgmType) {
            items.push({
                type: "list-item",
                label: formatMessage(messages.igg),
                value: formatMessageMap(hcv_1.resultMessages, event.value.igG)
            });
            if (event.value.igM) {
                items.push({
                    type: "list-item",
                    label: formatMessage(messages.igm),
                    value: formatMessageMap(hcv_1.resultMessages, event.value.igM)
                });
            }
        }
        if (hbvType) {
            if (event.value.aHBctotal) {
                items.push({
                    type: "list-item",
                    label: formatMessage(messages.aHBctotal),
                    value: formatMessageMap(hcv_1.resultMessages, event.value.aHBctotal)
                });
            }
            items.push({
                type: "list-item",
                label: formatMessage(messages.antiHBs),
                value: formatMessageMap(hcv_1.resultMessages, event.value.antiHBs)
            }, {
                type: "list-item",
                label: formatMessage(messages.antiHBsValue),
                value: `${event.value.antiHBsValue === undefined
                    ? ""
                    : event.value.antiHBsValue}`
            }, {
                type: "list-item",
                label: formatMessage(messages.hbsAg),
                value: formatMessageMap(hcv_1.resultMessages, event.value.HBsAg)
            });
            if (event.value.HBImmun) {
                items.push({
                    type: "list-item",
                    label: formatMessage(messages.HBImmun),
                    value: formatMessageMap(hbvStatus_1.hbimmunMessages, event.value.HBImmun)
                });
            }
        }
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: `${formattedTimestamp} - ${formatMessage(label)}`,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
}
